import React, {useEffect, useRef} from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate, useParams } from "react-router-dom"
import {fetchAutologin} from 'modules/login/actions'
import route from 'utils/enums/route'

const Auth = ({component: Component}) => {
    const isAuthorized = useSelector((state) => state.login.isAuthorized)
	const autologinFailed = useSelector((state) => state.login.autologinFailed)
    const navigate = useNavigate()
    const params = useParams()
    const dispatch = useDispatch()
    const isMounted = useRef(false)

    useEffect(() => {
        if (!isAuthorized) {
            dispatch(fetchAutologin())
        }
	}, [])

    useEffect(() => {
        if (isMounted.current) {
            if (!isAuthorized || autologinFailed) {
                navigate(`/${route.Login}`)
            }
          } else {
              isMounted.current = true
          }
	}, [isAuthorized, autologinFailed])

    return (
        <div>
            {isAuthorized &&
                <Component params={params} navigate={navigate} />
            }
        </div>
    )
}

export default Auth
